/*
  课程介绍组件 会显示课程详情 包含当前课程的套餐课 专题课
  courseInfo: 课程详情数据
*/

<template>
  <div v-if="courseInfo.courseViewDataList && courseInfo.courseViewDataList.length > 0" class="have_detail_list">
    <div class="have_detail_title">
      包含该课程的还有
    </div>
    <div class="have_scroll_view">
      <div v-if="opts.scrollX > 0" class="have_scroll_left" @click="lastScroll">
        <el-icon><arrow-left /></el-icon>
      </div>
      <div
        ref="scroll"
        class="have_scroll_x"
        :style="opts.style"
        @scroll="handleScrollX"
      >
        <div
          v-for="(item, idx) in courseViewDataList"
          :key="idx"
          class="course_have_item"
          @click="handleBuy(item)"
        >
          <img
            class="course_have_img"
            :src="item.courseCover"
          >
          <div class="course_have_msg">
            <div class="course_item_title">
              {{ item.courseName }}
            </div>
            <span class="course_item_courseware">{{ item.resourceCount }}个课件</span>
          </div>
        </div>
      </div>
      <div v-if="getScrollRight()" class="have_scroll_right" @click="nextScroll">
        <el-icon><arrow-right /></el-icon>
      </div>
    </div>
  </div>
  <div
    class="detail_desc_content"
    v-html="courseIntro"
  />
</template>

<script>

import { toRefs } from 'vue'
import { ArrowLeft, ArrowRight } from '@element-plus/icons-vue'
import { forbidCopy } from '../../utils'

export default {
  name: 'CourseDetails',
  components: { ArrowLeft, ArrowRight},
  props: {
    // 课程详情数据
    courseInfo: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  setup (props, { emit }) {
    const opts = reactive({
      scrollX: 0,
      style: {
        width: '1100px'
      }
    })
    const router = useRouter()
    const route = useRoute()
    const { courseInfo } = toRefs(props)
    const scroll = ref(null)
    const courseViewDataList = computed(() => {
      if (courseInfo.value) {
        return courseInfo.value.courseViewDataList || []
      }
      return []
    })
    const courseIntro = computed(() => {
      let text = ''
      if (courseInfo.value) {
        text = courseInfo.value.courseIntro || ''
      }
      if (text) {
        text = text
          .replace(
            /<a style="position: relative; width: 144px; height: 80px; margin: {2}10px; display: inline-block;/,
            '<a style="position: relative; width: 144px; height: auto; margin:  10px; display: inline-block;'
          )
          .replace(/<img/g, '<img style="width:100%"')
      }
      return text
    })
    const getScrollRight = () => {
      // 获取右侧按钮是否显示
      if (!courseViewDataList.value || !courseViewDataList.value.length) {
        return false
      } else {
        if (scroll.value) {
          const scrollLength = scroll.value.scrollWidth - scroll.value.offsetWidth
          return (scrollLength !== scroll.value.scrollLeft && courseViewDataList.value.length > 3)
        } else {
          return false
        }
      }
    }
    // 向右滚动
    const nextScroll = () => {
      scroll.value.scrollLeft += 327 * 3
      opts.scrollX = scroll.value.scrollLeft
    }

    // 向左滚动
    const lastScroll = () => {
      scroll.value.scrollLeft -= 327 * 3
      if (scroll.value.scrollLeft < 0) {
        scroll.value.scrollLeft = 0
      }
      opts.scrollX = scroll.value.scrollLeft
    }

    // 滚动轴事件
    const handleScrollX = () => {
      if (scroll.value.scrollLeft < 0) {
        scroll.value.scrollLeft = 0
      }
      opts.scrollX = scroll.value.scrollLeft
    }

    const handleBuy = (row) => {
      if (row) {
        let pathRouter = ''
        if (row.courseType === 6) {
          // 跳转大专题
          pathRouter = router.resolve({
            path: '/course/topic',
            query: {
              id: row.id
            }
          })
        } else {
          pathRouter = router.resolve({
            path: '/course/subject',
            query: {
              id: row.id,
              topicId: route.query.id
            }
          })
        }
        window.open(pathRouter.href)
      }
    }

    onMounted(() => {
      if (courseInfo.value && courseInfo.value.enableForbidContentCopy) {
        forbidCopy('.detail_desc_content')
      }
    })

    return {
      opts,
      scroll,
      courseInfo,
      courseIntro,
      courseViewDataList,
      handleBuy,
      nextScroll,
      lastScroll,
      handleScrollX,
      getScrollRight
    }
  }
}
</script>

<style scoped lang="scss">
.have_detail_list {
  margin-bottom: 30px;
}
.have_detail_title {
  font-style: normal;
  font-weight: 550;
  font-size: 16px;
  color: #333333;
  margin-bottom: 10px;
}
.have_scroll_view {
  display: flex;
  align-items: flex-start;
}
.have_scroll_left {
  margin-right: 10px;
}
.have_scroll_right {
  margin-left: 10px;
}
.have_scroll_left,
.have_scroll_right {
  background: #f6f8fb;
  height: 70px;
  border-radius: 5px;
  padding: 27px 7px;
  cursor: pointer;
}
.course_have_item {
  cursor: pointer;
  display: flex;
  height: 70px;
  flex-direction: row;
  align-items: center;
  padding: 10px;
  width: 317px;
  max-width: 317px;
  min-width: 317px;
  border-radius: 10px;
  background-color: #f6f8fb;
  position: relative;
  .course_have_img {
    width: 90px;
    height: 50px;
    border-radius: 10px;
    object-fit: cover;
  }
  & + .course_have_item {
    margin-left: 10px;
  }
  .course_have_msg {
    margin-left: 10px;
    width: calc(100% - 20px - 90px - 10px);
  }
  .course_item_courseware {
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    color: #999999;
  }
  .course_item_title {
    width: 100%;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    color: #333333;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
  &:before {
    content: ">";
    position: absolute;
    right: 13.5px;
    color: #becadb;
  }
}

.have_scroll_x {
  overflow-x: auto;
  height: 80px;
  display: inline-flex;
  &::-webkit-scrollbar {
    display: none;
  }
  &:hover::-webkit-scrollbar {
    display: block;
  }
}
</style>
